import styled from "styled-components";

export const StyledModalHeaderT1 = styled.div`
  background: #f9fafd;
  border-bottom: 1px solid #e9edf5;
  display: flex;
  font-weight: 600;
  justify-content: space-between;
  line-height: 24px;
  padding: 16px;
  align-items: center;
`;
